import auth0_spa_js from "@auth0/auth0-spa-js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { uncurry2, defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { FSharpResult$2, Result_MapError } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { decode } from "../Bindings/JWTDecode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Payload_get_Decoder } from "../ClientTypes.fs.js";
import { isNullOrEmpty } from "../fable_modules/fable-library-js.4.24.0/String.js";

const clientPromise = auth0_spa_js({ domain: "login.unasys.com", client_id: "P2CR6bKH0VyM3cplO37NMKlc2h0lAwmz", redirect_uri: window.location.origin, useRefreshTokens:true, cacheLocation:'memory', audience:'https://api.unasys.com', useFormData: true, sessionCheckExpiryDays: 1 });

function getToken(client) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (client.getTokenSilently())));
    return pr_1.catch((exn) => {
        const errorStr = toString(exn);
        if ((((errorStr.indexOf("login_required") >= 0) ? true : (errorStr.indexOf("No valid token") >= 0)) ? true : (errorStr.indexOf("Invalid state") >= 0)) ? true : (errorStr.indexOf("consent_required") >= 0)) {
            console.log(some("No session found - clearing cached tokens and redirecting to Universal Login"));
            const storage = localStorage;
            const length = storage.length | 0;
            for (let i = 0; i <= (length - 1); i++) {
                const key = storage.key(i);
                if ((key !== defaultOf()) && key.startsWith("@@auth0spajs@@")) {
                    storage.removeItem(key);
                }
            }
        }
        localStorage.setItem("auth0-redirect", window.location.href);
        const pr = client.loginWithRedirect({authorizationParams: {prompt: 'login'}});
        return pr.then((_arg) => "");
    });
}

export function getTokenSilently() {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => (getToken(_arg))))));
}

export function getUser() {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => (_arg.getUser().then((_arg_1) => (Promise.resolve(Result_MapError((e) => (new FetchError(1, [e])), new FSharpResult$2(0, [_arg_1]))))))))));
    return pr.catch((error) => (new FSharpResult$2(1, [new FetchError(0, [error])])));
}

export function getTokenProfile() {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => (getToken(_arg).then((_arg_1) => {
        const jwtJson = decode(_arg_1);
        const payload = fromString(uncurry2(Payload_get_Decoder()), jwtJson);
        return Promise.resolve(Result_MapError((e) => (new FetchError(1, [e])), payload));
    }))))));
    return pr.catch((error) => (new FSharpResult$2(1, [new FetchError(0, [error])])));
}

export function handleAuthRedirect() {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => {
        const client = _arg;
        return client.handleRedirectCallback().then((_arg_1) => ((PromiseBuilder__Delay_62FBFDE1(promise, () => (client.getTokenSilently().then((_arg_2) => {
            console.log(some("Session cookie established via token refresh"));
            return Promise.resolve();
        }))).catch((_arg_3) => {
            console.warn(some("Token refresh failed, but proceeding anyway"));
            return Promise.resolve();
        })).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const redirectUrl = localStorage.getItem("auth0-redirect");
            localStorage.removeItem("auth0-redirect");
            return Promise.resolve(isNullOrEmpty(redirectUrl) ? "/" : redirectUrl);
        }))));
    }))));
}

export function logOut() {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => {
        const returnTo = window.location.origin;
        _arg.logout({returnTo: returnTo, logoutParams: {federated: false}});
        return Promise.resolve();
    }))));
    void pr;
}

export function loginWithUniversalRedirect() {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => ((_arg.loginWithRedirect({authorizationParams: {prompt: 'login'}})))))));
}

export function logOutUniversal() {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => {
        _arg.logout({returnTo: window.location.origin, logoutParams: {federated: false}});
        return Promise.resolve();
    }))));
    void pr;
}

export function isAuthenticated() {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (clientPromise.then((_arg) => (_arg.getUser().then((_arg_1) => (Promise.resolve(_arg_1.name !== ""))))))));
    return pr.catch((_arg_2) => (Promise.resolve(false)));
}

